var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M38 13.292a1.87 1.87 0 00-1.858-1.863h-2.697a44.689 44.689 0 00-1.139-3.124c-1.079-2.764-2.338-4.146-2.397-4.206l-.18-.12-.18-.06c-.18 0-3.357-.481-9.77-.541H18.28c-6.412.06-9.59.54-9.709.54l-.24.06-.12.12c-.06.06-1.318 1.443-2.397 4.207-.36.901-.78 1.983-1.139 3.124H1.858A1.87 1.87 0 000 13.292a1.87 1.87 0 001.858 1.863h1.319l-1.559 2.944V34.02c0 .36.24.601.6.601h5.394c.36 0 .6-.24.6-.6v-3.125h21.577v3.124c0 .36.24.601.599.601h5.394c.36 0 .6-.24.6-.6V18.098l-1.499-2.884h1.259c1.019-.06 1.858-.902 1.858-1.923zM2.817 33.42v-4.206c.78.96 2.098 1.502 4.196 1.622v2.584H2.817zm32.366 0h-4.196v-2.584c2.038-.18 3.357-.661 4.196-1.803v4.387zm0-15.022v5.408c0 4.747-1.079 5.888-5.514 5.888H8.09c-4.555 0-5.274-1.322-5.274-5.888V18.4l2.398-4.387H1.858c-.36 0-.66-.3-.66-.661 0-.36.3-.661.66-.661h3.656l.12-.42c.42-1.262.84-2.464 1.259-3.486C7.732 6.743 8.63 5.541 8.93 5.12c.839-.12 4.195-.48 9.95-.48L19 4.58h.18c5.754 0 9.11.42 9.95.48.359.42 1.258 1.622 2.037 3.665.42 1.022.84 2.163 1.259 3.485l.12.42h3.596c.36 0 .66.301.66.662 0 .36-.3.66-.66.66h-3.297l2.338 4.447zm-28.59.12a2.408 2.408 0 012.398 2.404 2.408 2.408 0 01-2.398 2.403 2.408 2.408 0 01-2.397-2.403 2.408 2.408 0 012.397-2.404zm0 3.605c.66 0 1.199-.54 1.199-1.201s-.54-1.202-1.199-1.202c-.66 0-1.199.54-1.199 1.202 0 .66.54 1.201 1.2 1.201zm22.776-1.201a2.408 2.408 0 012.398-2.404 2.408 2.408 0 012.397 2.404 2.408 2.408 0 01-2.397 2.403 2.408 2.408 0 01-2.398-2.403zm3.596 0c0-.661-.54-1.202-1.198-1.202-.66 0-1.2.54-1.2 1.202 0 .66.54 1.201 1.2 1.201.659 0 1.198-.54 1.198-1.201z",
    id: "prefix__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 6.75v-4.5a2.25 2.25 0 114.5 0v4.5h4.5a2.25 2.25 0 110 4.5h-4.5v4.5a2.25 2.25 0 11-4.5 0v-4.5h-4.5a2.25 2.25 0 110-4.5h4.5z",
    id: "prefix__b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#323232",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a",
    transform: "translate(0 10)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#323232",
    xlinkHref: "#prefix__b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoPlus);
export default __webpack_public_path__ + "static/media/auto-plus.1d12a9c52f8e132bdaa22e9c8b77aef8.svg";
export { ForwardRef as ReactComponent };